module.exports = __webpack_public_path__ + "img/avaliacao.59df9857.svg";